import React from 'react';
import Countdown from './Countdown';
import Timeline from './Timeline';

function App() {
  const launchDate = new Date();
  launchDate.setDate(launchDate.getDate() + 14);
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white font-sans">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <h1 className="text-5xl font-bold text-center mb-6">Crypto that works</h1>
        <p className="text-center text-gray-400 mb-12 text-lg">LinkLayer goes live in...</p>
        <Countdown targetDate={launchDate} />
        <Timeline />
      </div>
    </div>
  );
}
export default App;
